import { FormControl } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import CustomValidators from '../../core/validators/custom-validators.validator';
import { MatChipGrid, MatChipInputEvent } from '@angular/material/chips';
import { DirtyPageComponent } from 'src/app/core/components/dirty-page.component';

@Component({
    selector: 'app-email-chiplist',
    templateUrl: './email-chiplist.component.html',
    styleUrls: ['./email-chiplist.component.scss'],
    standalone: false
})
export class EmailChiplistComponent extends DirtyPageComponent implements OnInit {
  @Input() initialValue: string[] = [];
  @Input() label: string | null = null;
  @Output() emailAddressesChange = new EventEmitter<string[]>();
  @Output() changed = new EventEmitter<void>();

  @ViewChild("chipList") chipList!: MatChipGrid;

  emailAddressesSet: Set<string> = new Set();

  emailAddressControl: FormControl<string | null> = new FormControl(null, { validators: CustomValidators.email });

  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.initDirtyCheckControl(this.emailAddressControl!);

    if (this.initialValue.length > 0) {
      this.initialValue.forEach(emailAddress => this.emailAddressesSet.add(emailAddress));
    }

    this.emailAddressControl.statusChanges.subscribe(controlState => {
      if (controlState === 'INVALID') {
        this.chipList.errorState = true;
      } else {
        this.chipList.errorState = false;
      }
    });
  }

  @Input()
  get emailAddresses(): string[] {
    return Array.from(this.emailAddressesSet);
  }
  set emailAddresses(newEmailAddresses: string[]) {
    this.emailAddressesSet.clear();

    if (newEmailAddresses?.length) {
      newEmailAddresses.forEach(emailAddress => this.emailAddressesSet.add(emailAddress));
    }
  }

  protected removeEmailAddress(emailAddress: string): void {
    this.emailAddressesSet.delete(emailAddress);
    this.changed.emit();
  }

  protected addEmailAddressFromInput(event: MatChipInputEvent) {
    if (event.value && this.emailAddressControl.valid) {
      this.emailAddressesSet.add(event.value);
      event.chipInput!.clear();
      this.emailAddressesChange.emit([...this.emailAddresses]);
      this.changed.emit();
    }
  }
}
